import { CustomSelectOption } from '@/components/CustomSelect/CustomSelectModel';
export default class Helper {
  generateQueryByFilters(
    propToReduce: CustomSelectOption[],
    key?: string,
    apiExtraKey?: string,
    filterValuesSeparator?: string,
    repeatForEachValue?: boolean
  ) {
    const query: string[] = propToReduce.reduce(
      (acc: string[], item: CustomSelectOption) => {
        if (item.isSelected) {
          return [...acc, `${item.uuid || item}`];
        }
        return [...acc];
      },
      []
    );

    if (key && query.length) {
      if (repeatForEachValue) {
        const values = query.map(val => `${apiExtraKey}:${val}`);
        return Helper.sanitizeQuery(
          `&${key}=${values.join(filterValuesSeparator)}`
        );
      } else {
        return Helper.sanitizeQuery(
          `&${key}=${apiExtraKey && `${apiExtraKey}:`}${query.join(
            filterValuesSeparator
          )}`
        );
      }
    }
    return Helper.sanitizeQuery(query.join(filterValuesSeparator));
  }

  generateQueryByFiltersWithSearch(
    propToReduce: CustomSelectOption[],
    key?: string,
    search?: string,
    apiExtraKey?: string,
    searchableFields?: string,
    filterValuesSeparator?: string,
    repeatForEachValue?: boolean
  ): string {
    let queryDone!: string;
    if (key)
      queryDone = `${this.generateQueryByFilters(
        propToReduce,
        key,
        apiExtraKey,
        filterValuesSeparator,
        repeatForEachValue
      )}`;
    if (search) {
      return Helper.sanitizeQuery(
        `&${queryDone}&${searchableFields}&search=${search}`
      );
    }
    return Helper.sanitizeQuery(queryDone);
  }

  handleScroll(call: any) {
    const element = document.querySelector('.router-view-container');
    if (element) {
      if (
        element.scrollTop + element.clientHeight + 40 >=
        element.scrollHeight
      ) {
        return call();
      }
    }
  }

  firstPagination = (skip: number, limit: number) =>
    `&skip=${skip}&limit=${limit}&`;

  capitalize(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  filterByStatus(
    props: CustomSelectOption[],
    title: string,
    labelToFilter?: string,
    apiExtraKey?: string,
    searchableFields?: string,
    filterValuesSeparator?: string,
    repeatForEachValue?: boolean
  ) {
    const modelFiltersSelected = props.filter(filter => filter.isSelected);
    const nameFilterSelected = Object.values(modelFiltersSelected).map(
      filter => filter.label
    );
    const query = this.generateQueryByFiltersWithSearch(
      props,
      labelToFilter || 'status',
      title,
      apiExtraKey,
      searchableFields,
      filterValuesSeparator,
      repeatForEachValue
    );
    const resume = {
      modelFiltersSelected,
      nameFilterSelected,
      query
    };
    return resume;
  }

  filterRemoved(
    filter: string,
    nameFiltersSelected: string[],
    groupFilterModel: any,
    currentTitle?: string
  ) {
    let newTitle = currentTitle || '';
    if (filter === currentTitle) newTitle = '';
    const newNamesFilterSelected = nameFiltersSelected.filter(
      (item: string) => item !== filter
    );

    const newFilters = groupFilterModel.filter((option: CustomSelectOption) => {
      if (
        option.uuid === filter.toLowerCase() ||
        option.label.toLowerCase() === filter.toLowerCase()
      ) {
        return (option.isSelected = false);
      }
      return option;
    });

    return {
      newTitle,
      newNamesFilterSelected,
      newFilters
    };
  }

  filterChanged(filters: string[], title: string) {
    if (!filters) return;
    const statusSelected: string[] = Object.values(filters);
    const listFiltersSelected = {
      status: [...statusSelected],
      title: [title]
    };
    return listFiltersSelected;
  }

  static sanitizeQuery(query: string) {
    return query
      .replace(/&&/g, '&')
      .replace(/&&&/g, '&')
      .replace(/,,/g, ',');
  }

  getFieldsIndexes(query: string, value: string) {
    const startFieldIndex = query.search(value) + value.length + 1;
    const substrQuery = query.substr(startFieldIndex);
    const endFieldIndex =
      substrQuery.search('&') > 0
        ? substrQuery.search('&')
        : substrQuery.length;
    return { startFieldIndex, substrQuery, endFieldIndex };
  }

  getFieldsByQuery(query: string, value: string) {
    const { substrQuery, endFieldIndex } = this.getFieldsIndexes(query, value);
    const fields = substrQuery.slice(0, endFieldIndex);
    return fields.split(',');
  }

  getSearchByQuery(query: string, searchableFields: string) {
    const index = query.search('search=');
    const subtrQuery = query.substr(index);
    const endIndex =
      subtrQuery.search('&') > 0 ? subtrQuery.search('&') : subtrQuery.length;
    return query.slice(index - searchableFields.length - 1, index + endIndex);
  }
}
